import { render, staticRenderFns } from "./adminEntry.vue?vue&type=template&id=bc56c704&"
import script from "./adminEntry.vue?vue&type=script&lang=js&"
export * from "./adminEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports